import { render } from "./AddCessionPage.vue?vue&type=template&id=521a619c&ts=true"
import script from "./AddCessionPage.vue?vue&type=script&lang=ts"
export * from "./AddCessionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__